"use client";

import { Button } from "@/components/ui/button";

interface RangeToggleProps {
  value: string;
  onChange: (value: string) => void;
  options?: { label: string; value: string }[];
}

export function RangeToggle({
  value,
  onChange,
  options = [
    { label: "7 Days", value: "7d" },
    { label: "30 Days", value: "30d" },
    { label: "90 Days", value: "90d" },
  ],
}: RangeToggleProps) {
  return (
    <div className="flex items-center gap-1 rounded-lg border p-1">
      {options.map((option) => (
        <Button
          key={option.value}
          variant={value === option.value ? "default" : "ghost"}
          size="sm"
          className="h-7 px-3 text-xs"
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
